import { render, staticRenderFns } from "./VDrugsSummary.vue?vue&type=template&id=2cdfb15a&scoped=true&"
import script from "./VDrugsSummary.vue?vue&type=script&lang=js&"
export * from "./VDrugsSummary.vue?vue&type=script&lang=js&"
import style0 from "./VDrugsSummary.vue?vue&type=style&index=0&id=2cdfb15a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdfb15a",
  null
  
)

export default component.exports